import * as React from 'react'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import {
  $DCprimaryColor,
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'

import { IPixelFactory } from '../../../../../../../decl'
interface IProps {
  handleClose: () => void
}

const CheckoutForm = ({ handleClose }: IProps) => {
  const elements = useElements()
  const stripe = useStripe()
  const { showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!stripe || !elements) {
      return
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href, // https://dev.pixelone.app/admin/subscription-plans
      },
    })

    if (result.error) {
      showFailure(result.error.message)
    } else if (result) {
      showSuccess('Payment method added successfully')
    }
  }

  return (
    <form
      style={{
        borderBottom: '1px solid #e3e3e3',
        padding: '20px',
      }}
      onSubmit={handleSubmit}
    >
      <PaymentElement />
      <PixelText style={{ color: $DCprimaryColor, fontSize: '0.75rem' }}>
        Please note there will be a temporary charge of PKR 150 on your card.
      </PixelText>
      <PixelFlexBox height={'auto'} justifyContent={'space-between'}>
        <PixelFlexBox justifyContent={'flex-end'} gap={'10px'} padding={'8px'}>
          <PixelButton variant="outline" onClick={handleClose}>
            Close
          </PixelButton>
          <PixelButton type="submit">Add</PixelButton>
        </PixelFlexBox>
      </PixelFlexBox>
    </form>
  )
}

export default CheckoutForm
